import { useTranslation } from '@aimsos/i18n';

/**
 * Returns a display-safe name for a workspace.
 * Falls back to the i18n key `common.workspace` if the workspace has no name.
 */
export const useWorkspaceDisplayName = () => {
  const { t } = useTranslation('workspaces');
  return (workspace) => workspace?.name?.trim() || t('common.workspace');
};
